/**
 * Todas as permissões devem estar no enum principal para serem carregadas na inicialização
 */
export enum PermissionResourcesCorporateWall {
	MOVIMENTATIONS = "res://senior.com.br/analytics/hcm/career/employee/companyMovimentationsCorporateMural", //ok
	BIRTHDAY_PERSON = "res://senior.com.br/analytics/hcm/career/employee/birthdayCorporateMural", //ok
	BUSINESS_BIRTHDAY = "res://senior.com.br/analytics/hcm/career/employee/companyBirthdayCorporateMural" //ok
}

/**
 * Cards da página My, aba CorporateWall
 */
export enum PermissionResourcesCorporateWallMy {
	MOVIMENTATIONS = "res://senior.com.br/analytics/hcm/career/employee/companyMovimentationsCorporateMural",
	BIRTHDAY_PERSON = "res://senior.com.br/analytics/hcm/career/employee/birthdayCorporateMural",
	BUSINESS_BIRTHDAY = "res://senior.com.br/analytics/hcm/career/employee/companyBirthdayCorporateMural"
}
